const champ2022 = {
	Team: "Golden State Warriors*",
	"FG%": ".469",
	"3P%": ".364",
	"2P": "26.2",
	"FT%": ".769",
	ORB: "9.8",
	DRB: "35.7",
	AST: "27.1",
	STL: "8.8",
	BLK: "4.5",
	TOV: "14.9",
	PTS: "111.0",
};

const champ2021 = {
	Team: "Miluakee Bucks",
	"FG%": ".487",
	"3P%": ".389",
	"FT%": ".760",
	ORB: "10.3",
	DRB: "37.8",
	AST: "25.5",
	STL: "8.1",
	BLK: "4.6",
	TOV: "13.8",
	PTS: "120.1",
};

const champ2020 = {
	Team: "Los Angeles Lakers",
	"FG%": ".480",
	"3P%": ".349",
	"FT%": ".729",
	ORB: "10.7",
	DRB: "35.1",
	AST: "25.4",
	STL: "8.6",
	BLK: "6.6",
	TOV: "15.2",
	PTS: "113.4",
};

const champ2019 = {
	Team: "Toronto Raptors",
	"FG%": ".474",
	"3P%": ".366",
	"FT%": ".804",
	ORB: "9.6",
	DRB: "35.6",
	AST: "25.4",
	STL: "8.3",
	BLK: "5.3",
	TOV: "14.0",
	PTS: "114.4",
};

const champ2016 = {
	Team: "Cleveland Caveliers",
	"FG%": ".487",
	"3P%": ".363",
	"FT%": ".778",
	ORB: "9.7",
	DRB: "32.0",
	AST: "24.9",
	STL: "7.2",
	BLK: "4.4",
	TOV: "13.6",
	PTS: "112.0",
};

const champ2014 = {
	Team: "San Antonio Spurs",
	"FG%": ".486",
	"3P%": ".397",
	"FT%": ".785",
	ORB: "9.3",
	DRB: "34.0",
	AST: "25.2",
	STL: "7.4",
	BLK: "5.1",
	TOV: "14.4",
	PTS: "105.4",
};

const champ2013 = {
	Team: "Miami Heat",
	"FG%": ".496",
	"3P%": ".396",
	"FT%": ".754",
	ORB: "8.2",
	DRB: "30.4",
	AST: "23.0",
	STL: "8.7",
	BLK: "5.4",
	TOV: "13.9",
	PTS: "102.9",
};

const champ2011 = {
	Team: "Dallas Mavericks",
	"FG%": ".475",
	"3P%": ".365",
	"FT%": ".777",
	ORB: "9.5",
	DRB: "31.9",
	AST: "23.8",
	STL: "6.8",
	BLK: "4.3",
	TOV: "14.0",
	PTS: "100.2",
};

const champ2008 = {
	Team: "Boston Celtics",
	"FG%": ".475",
	"3P%": ".381",
	"FT%": ".771",
	ORB: "10.1",
	DRB: "31.9",
	AST: "22.4",
	STL: "8.5",
	BLK: "4.6",
	TOV: "15.2",
	PTS: "100.5",
};

const champ2004 = {
	Team: "Detroit Pistons",
	"FG%": ".435",
	"3P%": ".344",
	"FT%": ".753",
	ORB: "12.4",
	DRB: "30.4",
	AST: "20.8",
	STL: "8.0",
	BLK: "7.0",
	TOV: "15.1",
	PTS: "90.1",
};

export {
	champ2022,
	champ2021,
	champ2020,
	champ2019,
	champ2016,
	champ2014,
	champ2013,
	champ2011,
	champ2008,
	champ2004,
};
